import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgZorroAntdModule } from "ng-zorro-antd";
import { BcacMultipleSelectComponent } from './bcac-multiple-select.component';



@NgModule({
  declarations: [BcacMultipleSelectComponent],
  imports: [
    CommonModule,
    NgZorroAntdModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [BcacMultipleSelectComponent]
})
export class BcacMultipleSelectModule { }
